import { ChangeEvent, useState } from "react";

const useInput = (initialValue: any) => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (
    event: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement>,
  ) => {
    setValue(event.target.value);
  };

  const changeValue = (value: any) => {
    setValue(value);
  };

  return {
    value,
    onChange: handleChange,
    changeValue: changeValue,
  };
};

export default useInput;
